import { render, staticRenderFns } from "./orgRole.vue?vue&type=template&id=1645a57d&scoped=true"
import script from "./orgRole.vue?vue&type=script&lang=js"
export * from "./orgRole.vue?vue&type=script&lang=js"
import style0 from "./orgRole.vue?vue&type=style&index=0&id=1645a57d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1645a57d",
  null
  
)

export default component.exports